import workspaceQuery from 'graphql/queries/salesLedger/SalesCreditLineWorkspaceQuery.graphql';
import aggregateQuery from 'graphql/queries/salesLedger/SalesCreditLineAggregateQuery.graphql';
import { EntityType } from '../../../@types/entityTypes';

const SalesCreditLine: EntityType = {
  type: 'SalesCreditLine',
  title: 'Sales Credit Lines',
  workspace: workspaceQuery,
  workspaceUrl: '/Customers/CreditLine/Workspace/',
  formTitle: 'Sales Credit',
  formUrl: '/Customers/Credit/Details/',
  aggregate: aggregateQuery,
  screenReference: 'SALES_LEDGER_CREDIT_LINES',
  dropdown: {
    query: workspaceQuery,
    valueKey: 'id',
    labelKey: 'id',
  },
};

export default SalesCreditLine;
